import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CleanupExtensionAttributes"] */ "/vercel/path0/components/CleanupExtensionAttributes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/vercel/path0/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalQuickAdd"] */ "/vercel/path0/components/GlobalQuickAdd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VercelToolbar"] */ "/vercel/path0/components/VercelToolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
